// extracted by mini-css-extract-plugin
export default {"blink":"NXJPzqwLAk8godVfsO9X"};